/**
 * Count words in a text string
 */
export function countWords(text: string): number {
  if (!text || !text.trim()) return 0;

  // Remove HTML tags if present
  const plainText = text.replace(/<[^>]*>/g, ' ');

  // Split by whitespace and filter empty strings
  const words = plainText
    .trim()
    .split(/\s+/)
    .filter((word) => word.length > 0);

  return words.length;
}

/**
 * Count characters in a text string (excluding HTML)
 */
export function countCharacters(text: string, includeSpaces = true): number {
  if (!text) return 0;

  // Remove HTML tags
  const plainText = text.replace(/<[^>]*>/g, '');

  if (includeSpaces) {
    return plainText.length;
  }

  return plainText.replace(/\s/g, '').length;
}

/**
 * Format large numbers with locale-specific separators
 */
export function formatNumber(num: number, locale = 'en-US'): string {
  return new Intl.NumberFormat(locale).format(num);
}

/**
 * Calculate reading time based on average reading speed
 */
export function calculateReadingTime(wordCount: number): string {
  const wordsPerMinute = 200;
  const minutes = Math.ceil(wordCount / wordsPerMinute);

  if (minutes < 1) return '< 1 min';
  if (minutes === 1) return '1 min';
  if (minutes < 60) return `${minutes} min`;

  const hours = Math.floor(minutes / 60);
  const remainingMinutes = minutes % 60;

  if (remainingMinutes === 0) {
    return `${hours} hr`;
  }

  return `${hours} hr ${remainingMinutes} min`;
}
